import AlphanumericEncoder from 'alphanumeric-encoder';
import { romanToArab, arabToRoman, isValidArab, isValidRoman } from 'roman-numbers';
const encoder = new AlphanumericEncoder()

export default {
    methods: {
        getParentReferenceNumber: function (parentNode, previousReference, firstParent) {
            var referenceNumber = parentNode.updatedReferenceNumber ? parentNode.updatedReferenceNumber : parentNode.referenceNumber;

            if (referenceNumber) {
                return `${referenceNumber}.${previousReference}`
            }
            return previousReference;
        },
        referenceNumberFormatter: function (type, index) {
            switch (type) {
                case 'arab':
                    return index.toString();
                case 'alphaupper':
                    return encoder.encode(index).toUpperCase();
                case 'alphalower':
                    return encoder.encode(index).toLowerCase();
                case 'romanupper':
                    return arabToRoman(index).toUpperCase();
                case 'romanlower':
                    return arabToRoman(index).toLowerCase();
                default:
            }
        },
        prettyDiff(previousText, newText) {

            if (typeof previousText == 'undefined' || previousText == null) {
                previousText = '';
            }
            if (typeof newText == 'undefined' || newText == null) {
                return '';
            }
     

            let dmp = new diff_match_patch();
            var diff = dmp.diff_main(previousText, newText);
            var result = dmp.diff_prettyHtml(diff)
            return result;
        },
        prettyDiffReferenceNumber(previousText, newText) {

            var result = '';
            if (previousText == newText) {
                return newText;
            }
            result += this.prettyDiff(previousText, "");
            result += this.prettyDiff("", newText);
            return result;
        },
        addBoldClass(value) {
            return value.replace('<ins style="background:#e6ffe6;">', '<ins class="has-text-weight-bold" style="background: #e6ffe6;">');
        },
        getNewTree: function () {

            var out = this.flatten([], this.treeData.children);

            var newTree = out.map(function mapper(item) {
                var newItem = Object.assign({}, item);
                if (newItem.children) {
                    newItem.children = undefined;
                }
                if (newItem.changeType == 'Added' && item.id == 'X') {
                    newItem.id = 0;
                }
                newItem.parent = undefined;

                if (item.pid == 0) newItem.pid = null;
                if (item.pid) {
                    newItem.pid = item.pid.toString();
                }
                return newItem;
            })
            return newTree;
        },
        flatten: function (into, node) {
            if (node == null) return into;
            if (Array.isArray(node)) return node.reduce(this.flatten, into);
            into.push(node);
            return this.flatten(into, node.children);
        },
    },
    computed: {
        descriptionLabel: function () {
            return window.labels.description;
        },
        groupLabel: function () {
            return window.labels.group;
        },
        classLabel: function () {
            return window.labels.class;
        },
        subclassLabel: function () {
            return window.labels.subclass;
        },
        detailsLabel: function () {
            return window.labels.codeText;
        },
        aboveLabel: function () {
            return window.labels.above;
        },
        belowLabel: function () {
            return window.labels.below;
        },
        childLabel: function () {
            return window.labels.child;
        },
        editLabel: function () {
            return window.labels.editItem;
        },
        deleteLabel: function () {
            return window.labels.deleteItem;
        },
        referenceNumberLabel: function () {
            return window.labels.referenceNumber;
        },
        referenceNumberingLabel: function () {
            return window.labels.referenceNumbering;
        },
        nameLabel: function () {
            return window.labels.name;
        },
        entityNameLabel: function () {
            return window.labels.entityName;
        },
        entityOriginalNameLabel: function () {
            return window.labels.entityOriginalName;
        },
        multipleColumnsLabel: function () {
            return window.labels.multipleColumns;
        },
        exclusionLabel: function () {
            return window.labels.exclusion;
        },
        saveLabel: function () {
            return window.labels.save;
        },
        cancelLabel: function () {
            return window.labels.cancel;
        },
        addLabel: function () { return window.labels.addNewEntry; },
        arrangeNumberingLabel: function () { return window.labels.arrangeNumbering; },
        arabLabel: function () { return window.labels.arab; },
        alphaUpperLabel: function () { return window.labels.alphabetUpper; },
        alphaLowerLabel: function () { return window.labels.alphabetLower; },
        romanUpperLabel: function () { return window.labels.romanUpper; },
       
        romanLowerLabel: function () { return window.labels.romanLower; },
        addNoteItemLabel: function () { return window.labels.addNoteItem; },
        goodsLabel: function () { return window.labels.goodsDetails },
        notesLabel: function () { return window.labels.notes },
        servicesLabel: function () { return window.labels.servicesDetails },
        constructionServicesLabel: function () { return window.labels.constructionServicesDetails },
        classificationSystemLabel: function () { return window.labels.classificationSystem },
        treeViewMenuTooltip: function () { return window.labels.coverageTreeViewMenuTooltip },
        noteAboveLabel: function () { return window.labels.noteAbove },
        noteBelowLabel: function () { return window.labels.noteBelow },
        childNoteLabel: function () { return window.labels.childNote },
        entityFormTitle: function () { return window.labels.entityFormTitle },
        editTooltip: function () { return window.labels.editTooltip },
        deleteTooltip: function () { return window.labels.deleteTooltip },
        numberingTooltip: function () { return window.labels.numberingTooltip },
        entitySuffixSymbolLabel: function () { return window.labels.entitySuffixSymbol },
        entityDefineSuffixLabel: function () { return window.labels.entityDefineSuffix },
        saveLabel: function () { return window.labels.saveItem },
        cancelLabel: function () { return window.labels.cancel },
        noteDetails: function () { return window.labels.noteDetails },
        noteText: function () { return window.labels.noteText },
        noteTextTooltip: function () { return window.labels.noteTextTooltip },

        exclusionLabel: function () { return window.labels.exclusionLabel },
        exclusionTooltip: function () { return window.labels.exclusionTooltip },

        classificationSystemTooltip: function () { return window.labels.classificationSystemTooltip },

        referenceNumberingTooltip: function () { return window.labels.referenceNumberingTooltip },
        entityNameTooltip:  function() { return window.labels.entityNameTooltip },
        entityOriginalNameTooltip: function () { return window.labels.entityOriginalNameTooltip },
        entitySuffixSymbolTooltip: function () { return window.labels.entitySuffixSymbolTooltip },
        entityDefineSuffixTooltip: function () { return window.labels.entityDefineSuffixTooltip },
        addNewEntryTooltip: function () { return window.labels.coverageAddNewEntryTooltip },
        footnoteDetails: function () { return window.labels.coverageFootnoteDetails }, 
        addGoodsItem: function () { return window.labels.coverageAddGoodsItem }, 
        addServicesItem: function () { return window.labels.coverageAddServicesItem }, 
        addConstructionItem: function () { return window.labels.coverageAddConstructionServicesItem }, 
        coverageDescription: function () { return window.labels.coverageDescription }, 
        coverageDescriptionTooltip: function () { return window.labels.coverageDescriptionTooltip }, 
        multipleColumnTooltip: function () { return window.labels.coverageMultipleColumnTooltip }, 

    }

}